import { EnvName } from '../types/environment';
import { getP44Env } from './getP44Env';

const { ENV, MOVEMENT_BASE_URL } = getP44Env();

interface CustomEnv {
  MAPBOX_GL: string;
}

const envMap: Record<EnvName, CustomEnv> = {
  'qa-integration': {
    MAPBOX_GL:
      'pk.eyJ1IjoiamtsZWdzZXRoIiwiYSI6ImNrN3l5NW84azAwbGUzbHJ5bGNhZHVhM2MifQ.9QXwfzKKp-s-mAE-qhachw',
  },
  'qa-stage': {
    MAPBOX_GL:
      'pk.eyJ1IjoiYWpub2x0ZTEyIiwiYSI6ImNrdGMweTBxbjIxbmcydXMxNGo0eDF2bncifQ.MDhxC8bxmpJWBCSBUiqBXg',
  },
  'production-eu': {
    MAPBOX_GL:
      'pk.eyJ1IjoiYWpub2x0ZTEyIiwiYSI6ImNrdGMweWxoNjAzbngyd3Bmd2F0Y3Y3cnYifQ.lG00SMQtLvEmcNQV0yRVCg',
  },
  'production-na': {
    MAPBOX_GL:
      'pk.eyJ1IjoiYWpub2x0ZTEyIiwiYSI6ImNrdGMweWxoNjAzbngyd3Bmd2F0Y3Y3cnYifQ.lG00SMQtLvEmcNQV0yRVCg',
  },
  sandbox: {
    MAPBOX_GL:
      'pk.eyJ1IjoiYWpub2x0ZTEyIiwiYSI6ImNrdGMweWxoNjAzbngyd3Bmd2F0Y3Y3cnYifQ.lG00SMQtLvEmcNQV0yRVCg',
  },
};

export const MOVEMENT_LOGIN_PAGE = `${MOVEMENT_BASE_URL}/login`;
export const MAPBOX_GL = envMap[ENV].MAPBOX_GL;
